/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
// import fetch from 'isomorphic-unfetch';
import Typography from '../../atoms/Typography'
import { PhoneContainer } from './style';

       
const PhoneInput = ({
  onChange,
  code,
  value,
  label,
  disabled,
  containerStyle,
  inputStyle,
  buttonStyle,
  inputProps,
}) => {
  const [countryInfo, setCountryInfo] = React.useState({
    country: 'BE',
  });

  React.useEffect(() => {
    fetch(`https://ipinfo.io?token=${process.env.NEXT_PUBLIC_IP_STACK_KEY}`)
      .then((response) => response.json())
      .then((data) => {
        setCountryInfo({ ...data });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }, []);

  const getDefaultCountry = () => {
    if (code) return code.toLowerCase();
    if (value && value?.startsWith('+')) {
      // Extract country code from value
      const countryCode = value?.replace(/\D/g, '').substring(0, 2); // adjust as necessary
      return countryCode?.toLowerCase();
    }
    return countryInfo?.country?.toLowerCase();
  };


  return (
    <PhoneContainer
    // Uncomment those for material theme
    // color={color} label={label}
    >
      <Typography variant="body1">{label}</Typography>
      <ReactPhoneInput
        country={getDefaultCountry()}
        value={value}
        onChange={onChange}
        disabled={disabled}
        inputProps={inputProps}
        containerStyle={containerStyle}
        inputStyle={inputStyle}
        buttonStyle={buttonStyle}
      />
    </PhoneContainer>
  );
};

PhoneInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  // color: PropTypes.string,
  label: PropTypes.string,
  code: PropTypes.string,
  inputProps: PropTypes.object,
  containerStyle: PropTypes.object,
  inputStyle: PropTypes.object,
  buttonStyle: PropTypes.object,
};

PhoneInput.defaultProps = {
  disabled: false,
  // color: 'primary',
  label: 'Phone',
  code: null,
  inputProps: {},
  containerStyle: null,
  inputStyle: null,
  buttonStyle: null,
};

export default PhoneInput;
